// Les notes des recherches de contacts sont écrites en français par le worker ; l'interface les traduit
// phrase par phrase, et laisse telle quelle une phrase qu'elle ne connaît pas.
type Translate = (key: string, options?: Record<string, unknown>) => string;

const SENTENCES: [RegExp, string][] = [
  [/Aucune adresse trouvée\./, "no_email"],
  [/Aucun mobile trouvé\./, "no_mobile"],
  [/Aucun profil LinkedIn trouvé\./, "no_linkedin"],
  [/Adresse déjà connue\./, "known_email"],
  [/Prénom, nom ou société manquant : recherche impossible\./, "missing_name"],
  [/Contact sur la liste d'opposition\./, "suppressed"],
  [/Société sur la liste d'opposition\./, "company_suppressed"],
  [
    /Recherche indisponible pour le moment, aucun crédit débité\./,
    "unavailable",
  ],
  [
    /Plafond IA du mois atteint : les sites des sociétés n'ont pas été lus\./,
    "budget_sites",
  ],
  [
    /Plafond IA du mois atteint : la chaîne de décision n'a pas été proposée\./,
    "budget_chain",
  ],
  [/(\d+) contact\(s\) écarté\(s\) : liste d'opposition\./, "suppressed_count"],
  [/Déjà cherché sans résultat il y a moins de (\d+) jours\./, "missed"],
  [
    /Nos fournisseurs connaissent aussi l'adresse probable, sans pouvoir la vérifier : rien n'est débité\./,
    "probable_known",
  ],
  [
    /Seule une ligne fixe a été trouvée, gardée sur la fiche : rien n'est débité\./,
    "landline_only",
  ],
];

/** Avec une adresse probable affichée, « aucune adresse trouvée » se lit comme « aucune adresse vérifiée ». */
export const translateWorkerNote = (
  note: string,
  translate: Translate,
  { probable = false }: { probable?: boolean } = {},
) =>
  SENTENCES.reduce(
    (text, [pattern, key]) =>
      text.replace(new RegExp(pattern, "g"), (_, count) =>
        translate(
          `resources.projects.contacts.notes.${probable && key === "no_email" ? "probable_missed" : key}`,
          { count },
        ),
      ),
    note,
  );
